"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.s3KeyToBusinessId = exports.isAdditionalFileName = exports.FILE_S3_KEY_REGEXP = void 0;
const ADDITIONAL_FILE_S3_KEY_REGEXP = /(?:.*\/){6}.*(Additional.*)/;
exports.FILE_S3_KEY_REGEXP = /(?:.*\/){5}.+_(.*)\..*/;
const S3_KEY_GROUPS_REGEX = /(?<centreId>.*)\/(?<seriesId>.*)\/(?<assessmentCode>.*)\/(?<componentNumber>.*)\/(?<learnerNumber>.*)\/(?<fileName>.*)/;
const ADDITIONAL_FILE_S3_KEY_GROUPS_REGEX = /(?<centreId>[^/]+)\/(?<seriesId>[^/]+)\/(?<assessmentCode>[^/]+)\/(?<componentNumber>[^/]+)\/(?<learnerNumber>[^/]+)\/(?<fileName>[^/]+)/;
const isAdditionalFileName = (s3Key) => {
    return Boolean(ADDITIONAL_FILE_S3_KEY_REGEXP.exec(s3Key));
};
exports.isAdditionalFileName = isAdditionalFileName;
const getRegexByS3Key = (s3Key) => {
    return (0, exports.isAdditionalFileName)(s3Key) ? ADDITIONAL_FILE_S3_KEY_GROUPS_REGEX : S3_KEY_GROUPS_REGEX;
};
const s3KeyToBusinessId = (s3Key) => {
    var _a, _b, _c;
    const match = exports.FILE_S3_KEY_REGEXP.exec(s3Key);
    if (match) {
        if (getRegexByS3Key(s3Key).exec(s3Key)) {
            const { centreId, seriesId, assessmentCode, componentNumber, learnerNumber, fileName } = ((_a = getRegexByS3Key(s3Key).exec(s3Key)) === null || _a === void 0 ? void 0 : _a.groups) || {};
            const sectionId = (_c = (_b = fileName === null || fileName === void 0 ? void 0 : fileName.split('_')) === null || _b === void 0 ? void 0 : _b.pop()) === null || _c === void 0 ? void 0 : _c.split('.')[0];
            return {
                centreId,
                seriesId: Number(seriesId),
                assessmentCode,
                componentNumber,
                learnerNumber: Number(learnerNumber),
                sectionId: Number(sectionId),
            };
        }
        else {
            throw new Error(`S3 key "${s3Key}" is not valid and can not be converted to businessId`);
        }
    }
    else {
        throw new Error(`S3 key "${s3Key}" is not valid and can not be converted to businessId`);
    }
};
exports.s3KeyToBusinessId = s3KeyToBusinessId;
